import { useState } from 'react';

import { Form } from './components/Form.tsx';
import { Success } from './components/Success';
import { TaxonomyProvider } from './context/TaxonomyContext';

export function AdminTaxonomy() {
  const [isSuccess, setIsSuccess] = useState(false);
  function handleSuccess(value: boolean) {
    setIsSuccess(value);
  }

  return (
    <TaxonomyProvider>
      {isSuccess && <Success onSuccess={handleSuccess} />}
      {!isSuccess && <Form onSuccess={handleSuccess} />}
    </TaxonomyProvider>
  );
}
